import { getClient } from "../components/utilities";

const Header = {
  lastScrollTop: -1,
  scrollTop: window.pageYOffset,
  header: document.querySelector('#header'),

  handleMenuImages: function() {
    // carrega as imagens dos menus somente quando dá hover no menu
    const menus = document.querySelectorAll('.menu-desktop .item');

    if (menus.length > 0) menus.forEach(menu => {
      menu.addEventListener('mouseenter', () => {
        const images = document.querySelectorAll('[data-src]');

        if (images.length > 0) images.forEach(image => {
          image.setAttribute('src', image.getAttribute('data-src'));
          image.classList.add('lazy')
          image.classList.add('loaded')
          image.removeAttribute('data-src')
        })
      })
    })
  },

  setScroll: function (scrollTop, lastScrollTop) {
    const _this = this;

    if (scrollTop <= 0) {
      _this.header.classList.add('scroll-up');
      _this.header.classList.remove('scroll-down');
      _this.header.classList.add('on-top');
    } else {
      if (_this.header.classList.contains('on-top')) {
        _this.header.classList.remove('on-top');
      }
      if (scrollTop > lastScrollTop) {
        _this.header.classList.add('scroll-down');
        _this.header.classList.remove('scroll-up');
      } else {
        _this.header.classList.add('scroll-up');
        _this.header.classList.remove('scroll-down');
      }
    }
  },

  init: function () {
    Header.handleMenuImages()

    const _this = this;
    const { lastScrollTop, scrollTop } = _this;

    _this.setScroll(scrollTop, lastScrollTop);

    // cuida quando a página scrolla pra atualizar o header
    window.addEventListener('scroll', function () {
      const newSt = window.pageYOffset;

      _this.setScroll(newSt, lastScrollTop);
      _this.lastScrollTop = newSt;
    });

    async function init() {
        const client = await getClient();
       
        if (client) {
            const clientTag = client.tags;
            const handleBtnCupom = document.querySelector('.context-cupom-product .context-text .ticket-default');
            const newBtnCupom = document.querySelector('button.btn-ticket-show');
            const newBtnCupomText = newBtnCupom.querySelector('span')
    
          
            
            if(clientTag == 'diamante'){
                // alert('tem a tag vip')
                newBtnCupomText.textContent = clientTag;
                handleBtnCupom.classList.add('-desatived');
                newBtnCupom.classList.remove('-desatived');
            }else if(clientTag == 'ouro'){
                newBtnCupomText.textContent = clientTag;
                handleBtnCupom.classList.add('-desatived');
                newBtnCupom.classList.remove('-desatived');
            }else if(clientTag == 'prata'){
                newBtnCupomText.textContent = clientTag;
                handleBtnCupom.classList.add('-desatived');
                newBtnCupom.classList.remove('-desatived');
            }else if(clientTag == 'bronze'){
                newBtnCupomText.textContent = clientTag;
                handleBtnCupom.classList.add('-desatived');
                newBtnCupom.classList.remove('-desatived');
            }      
    
            const btnSpaceSopy = newBtnCupom
            
            if(btnSpaceSopy){
               
                btnSpaceSopy.addEventListener('click', function(){
                  var copyText = btnSpaceSopy.querySelector("span");
                  var textNode = copyText.childNodes[0];
                
                
                  var range = document.createRange();
                  range.selectNode(textNode);
                
                
                  window.getSelection().removeAllRanges();
                  window.getSelection().addRange(range);
                
                  document.execCommand('copy');
                  btnSpaceSopy.querySelector('.img-ticket').innerHTML = 'copiado'
          
               
                  // alert("Cupom copiado: " + textNode.textContent.trim());
                })
            }
        } else {
            console.log('Nenhum cliente logado.');
        }
      }
      
      init();


    $('#header').hover(
      function() {
        $('.top-bar').addClass('color');
      }, 
      function() {
        $('.top-bar').removeClass('color');
      }
    );
  },
};


export default Header;
